export default __webpack_public_path__ + "271783ab277ff552b74a4151724bd9ca.svg";